/* eslint-disable indent */
import { RoleName } from '@/api/entities/user-role-type';
import { TUserEntityRoleSchema } from '@/schemas/user-entity-role/user-entity-role.schema';
import { QueryClient } from '@tanstack/react-query';
import { TFunction } from 'i18next';

interface GetRoleAndEntityLabelProps {
  t: TFunction<undefined>;
  role: TUserEntityRoleSchema;
}

export const invalidateUserEntityRoles = (
  queryClient: QueryClient,
  variables: TUserEntityRoleSchema
) => {
  const { userId, roleTypeId } = variables;

  queryClient.invalidateQueries({
    queryKey: ['listAllGroups'],
  });
  queryClient.invalidateQueries({
    queryKey: ['listAllCompanies'],
  });
  queryClient.invalidateQueries({
    queryKey: ['listAllBranches'],
  });
  queryClient.invalidateQueries({
    queryKey: ['getAllUsers'],
  });
  queryClient.invalidateQueries({
    queryKey: ['getAssignedAdmin', userId],
  });
  queryClient.invalidateQueries({
    queryKey: ['getAssignedModerator', userId],
  });
  queryClient.invalidateQueries({
    queryKey: ['getUnassignedGroupsToUser', userId],
  });
  queryClient.invalidateQueries({
    queryKey: ['getAssignedGroupsToUser', userId],
  });
  queryClient.invalidateQueries({
    queryKey: ['getUnassignedCompaniesToUser', userId],
  });
  queryClient.invalidateQueries({
    queryKey: ['getAssignedCompaniesToUser', userId],
  });
  queryClient.invalidateQueries({
    queryKey: ['getUnassignedBranchesToUser', userId],
  });
  queryClient.invalidateQueries({
    queryKey: ['getAssignedBranchesToUser', userId, roleTypeId],
  });
  queryClient.invalidateQueries({
    queryKey: ['getAllEntityRolesByUserId', userId],
  });
  queryClient.invalidateQueries({
    queryKey: ['getEntityRoleByUserId', userId],
  });
};

export const getPreparedEntityRoleLabel = ({
  t,
  role,
}: GetRoleAndEntityLabelProps) => {
  let roleLabel = '';
  let entityLabel = '';
  let fullEntityRoleLabel = '';

  switch (role?.roleType?.name) {
    case RoleName.ADMIN:
      roleLabel = t('common:administrator');
      break;
    case RoleName.MODERATOR:
      roleLabel = t('common:moderator');
      break;
    case RoleName.GROUP_MANAGER:
      roleLabel = t('common:groupManager');
      break;
    case RoleName.COMPANY_MANAGER:
      roleLabel = t('common:companyManager');
      break;
    case RoleName.BRANCH_MANAGER:
      roleLabel = t('common:branchManager');
      break;
    case RoleName.BRANCH_AGENT:
      roleLabel = t('common:branchAgent');
      break;
  }

  if (
    role?.roleType?.name === RoleName.ADMIN ||
    role?.roleType?.name === RoleName.MODERATOR
  ) {
    fullEntityRoleLabel = roleLabel;
  }

  if (role?.group) {
    entityLabel = role?.group?.name;
    fullEntityRoleLabel = `${roleLabel} - ${entityLabel}`;
  }

  if (role?.company) {
    entityLabel = role?.company?.name;
    fullEntityRoleLabel = `${roleLabel} - ${entityLabel}`;
  }

  if (role?.branch) {
    entityLabel = role?.branch?.name;
    fullEntityRoleLabel = `${roleLabel} - ${entityLabel}`;
  }

  return {
    roleLabel,
    entityLabel,
    fullEntityRoleLabel,
  };
};
